import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n'; // TODO: get rid of this import

import { TooltipModule } from './../tooltip/tooltip.module';
import { PaginationCounterComponent } from './pagination-counter.component';

@NgModule({
  declarations: [PaginationCounterComponent],
  exports: [PaginationCounterComponent],
  imports: [CommonModule, I18nModule, TooltipModule],
})
export class PaginationCounterModule {}
export { PaginationCounterComponent } from './pagination-counter.component';
